import { combineReducers } from 'redux'

import dashboard from './board'

export const reducer = combineReducers({
  dashboard: dashboard.reducer,
})

export default reducer
